import { render, staticRenderFns } from "./UserManager.vue?vue&type=template&id=1b971c36&scoped=true&"
import script from "./UserManager.vue?vue&type=script&lang=ts&"
export * from "./UserManager.vue?vue&type=script&lang=ts&"
import style0 from "./UserManager.vue?vue&type=style&index=0&id=1b971c36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b971c36",
  null
  
)

export default component.exports